<template>
  <div>
    <div class="input-tab">{{ $t('comparisonFeature.tools.tab') }}</div>
    <div class="input-card">
      <div class="title">
        <span>{{ $t('comparisonFeature.tools.title') }}</span>
        <ul class="selected-tool-list">
          <li
            v-for="tool in selectedComparisonToolList"
            :key="tool.id"
            class="selected-tool"
          >
            <span>
              {{ tool.name }}
            </span>
            <fa
              icon="times-circle"
              class="selected-tool__remove-icon"
              @click="removeFromSelectedComparisonToolList(tool)"
            ></fa>
          </li>
        </ul>
      </div>
      <div
        class="modal-switch"
        :class="{ disabled: isDisabled }"
        @click="showModal"
      >
        <span>{{ $t('comparisonFeature.tools.viewToolsBtn') }}</span>
        <fa icon="chevron-right"></fa>
      </div>
    </div>
    <add-tool-modal
      v-if="isShowToolsModal"
      @onCloseModal="handleCloseModal"
      @onApplyComparisonToolChange="handleComparisonToolChange"
    ></add-tool-modal>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import AddToolModal from './AddToolModal.vue';

export default {
  components: {
    AddToolModal,
  },

  data() {
    return {
      isShowToolsModal: false,
    };
  },

  computed: {
    ...mapState(['comparisonResourceList', 'selectedComparisonToolList']),

    isDisabled() {
      return this.comparisonResourceList.length === 0;
    },
  },

  methods: {
    ...mapMutations([
      'updateComparisonToolList',
      'removeFromComparisonToolList',
    ]),

    showModal() {
      if (this.isDisabled) return;

      this.updateComparisonToolList([...this.selectedComparisonToolList]);

      this.isShowToolsModal = true;
    },

    handleCloseModal() {
      this.isShowToolsModal = false;
    },

    removeFromSelectedComparisonToolList(tool) {
      this.removeFromComparisonToolList(tool);
    },

    handleComparisonToolChange() {
      this.$emit('fetchComparisonWidgets');
    },
  },

  watch: {
    selectedComparisonToolList() {
      // TODO: update data when selectedComparisonToolList is changed.
    },
  },
};
</script>

<style scoped lang="scss">
.input-tab {
  position: relative;
  width: 5rem;
  height: 2.75rem;
  line-height: 2.75rem;
  background-color: $apnic-blue;
  color: white;
  font-weight: 600;
  text-align: center;
}

.input-card {
  position: relative;
  background-color: white;
  min-width: 16rem;

  .title > span:nth-child(1) {
    display: inline-block;
    margin: 1rem;
    font-weight: 600;
    line-height: 1.5rem;
  }

  .selected-tool-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-content: center;
    padding: 0;
    margin: 0 0.5rem 1rem 0.5rem;
    overflow: hidden;
  }

  .selected-tool {
    flex: 0 1 45%;
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin: 0.25rem 0.25rem;
    padding: 0 0.5rem;
    box-sizing: border-box;
    min-width: 8rem;
    height: 2.75rem;
    line-height: 2.75rem;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.14),
      0px 3px 1px -2px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2);

    span {
      display: inline-block;
      margin-right: 0.5rem;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: $text-black;
    }

    &__remove-icon {
      width: 1.25rem;
      height: 1.25rem;
      font-size: 0.5rem;
      color: $icon-grey;
      cursor: pointer;
    }
  }

  .modal-switch {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0.5rem 1rem;
    margin-right: auto;
    border-top: 1px $text-grey solid;
    color: $apnic-blue;
    font-weight: 600;
    cursor: pointer;

    span {
      margin-right: 0.5rem;
      line-height: 1.7;
    }
  }

  .disabled {
    cursor: initial;
  }
}
</style>
